import { USER_LOGGED_IN, GET_LOGGED_USER, CHANGE_PASSWORD, UPDATE_PROFILE} from "../actions/index";
import _ from 'lodash';

export default function (state = {}, action) {
    switch (action.type) {
        case USER_LOGGED_IN:
            return action.payload;
        case CHANGE_PASSWORD:
             return action.payload;
        case UPDATE_PROFILE:
             _.remove(state, { id: action.payload.id });
            localStorage.setItem('logged_user', JSON.stringify(action.payload));
            return action.payload;
        case GET_LOGGED_USER:
            localStorage.setItem('logged_user', JSON.stringify(action.payload));
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js